import { NavItem } from './nav-item/nav-item';

export const adminItems: NavItem[] = [
  {
    navCap: 'Home',
  },
  {
    displayName: 'Dashboard',
    iconName: 'aperture',
    route: '/dashboard',
  },
 
  {
    navCap: 'Quick Actions',
  },
  {
    displayName: 'Service Providers',
    iconName: 'user-search',
    route: 'apps/suppliers',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/suppliers/add',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/suppliers/list',
      }
    ],
  },
  {
    displayName: 'Services',
    iconName: 'settings',
    route: 'apps/services',
    children: [
      {
        displayName: 'Service Requests',
        iconName: 'point',
        route: 'apps/services/service-requests',
      },
      {
        displayName: 'Service Categories',
        iconName: 'point',
        route: 'apps/services/service-categories',
      },
      {
        displayName: 'Services',
        iconName: 'point',
        route: 'apps/services/services',
      },
      {
        displayName: 'Reviews',
        iconName: 'point',
        route: 'apps/services/reviews',
      }
    ],
  },
 

  {
    displayName: 'Customers',
    iconName: 'users-group',
    route: 'apps/customers',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/customers/add',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/customers/list',
      }
    ],
  },




  // {
  //   displayName: 'Claims',
  //   iconName: 'stack-forward',
  //   route: 'apps/claims',
  //   children: [
  //     {
  //       displayName: 'Create Claim',
  //       iconName: 'point',
  //       route: 'apps/claims/create',
  //     },
     
  //     {
  //       displayName: 'Claim List',
  //       iconName: 'point',
  //       route: 'apps/claims/list',
  //     },
  //     {
  //       displayName: 'Settlements',
  //       iconName: 'point',
  //       route: 'apps/claims/settlement',
  //     },
  //   ],
  // },

  {
    navCap: 'Finance',
  },

  
  {
    displayName: 'Payment Methods',
    iconName: 'flag-dollar',
    route: 'apps/payments/payment-methods'
  },

  {
    displayName: 'Invoicing',
    iconName: 'receipt',
    route: 'apps/invoicing',
    children: [
      {
        displayName: 'Invoices',
        iconName: 'point',
        route: 'apps/invoicing/invoices',
      },
      {
        displayName: 'Create Invoice',
        iconName: 'point',
        route: 'apps/invoicing/invoices/create',
      },
      {
        displayName: 'Quotes',
        iconName: 'point',
        route: 'apps/invoicing/quotes',
      },
      {
        displayName: 'Credit Notes',
        iconName: 'point',
        route: 'apps/invoicing/credit-notes',
      },
      {
        displayName: 'Payment Terms',
        iconName: 'point',
        route: 'apps/invoicing/payment-terms',
      },
      {
        displayName: 'Invoice Templates',
        iconName: 'point',
        route: 'apps/invoicing/templates',
      }
    ],
  },
  {
    displayName: 'Transactions',
    iconName: 'credit-card',
    route: 'apps/transactions',
    children: [
      
      {
        displayName: 'Create Transaction',
        iconName: 'point',
        route: 'apps/transactions/create-transaction',
      },
      {
        displayName: 'Transactions List',
        iconName: 'point',
        route: 'apps/transactions/list',
      },
      {
        displayName: 'Transaction Types',
        iconName: 'point',
        route: 'apps/transactions/transaction-types',
      },
      {
        displayName: 'Create Invoice',
        iconName: 'point',
        route: 'apps/transactions/create-invoice',
      },
      {
        displayName: 'Recurrring Invoice',
        iconName: 'point',
        route: 'apps/transactions/recurring-invoices',
      },
      {
        displayName: 'Invoice List',
        iconName: 'point',
        route: 'apps/transactions/invoices',
      },
      {
        displayName: 'Credit Note',
        iconName: 'point',
        route: 'apps/transactions/credit-note',
      },
    ],
  },
  {
    displayName: 'Expense',
    iconName: 'receipt-2',
    route: 'apps/expenses',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/expenses/add',
      },
      {
        displayName: 'Expenses',
        iconName: 'point',
        route: 'apps/expenses/list',
      },
      
    ],
  },
  
  
  // {
  //   displayName: 'Banks',
  //   iconName: 'building-bank',
  //   route: 'apps/products',
  //   children: [
  //     {
  //       displayName: 'Add',
  //       iconName: 'point',
  //       route: 'apps/products/add',
  //     },
  //     {
  //       displayName: 'List',
  //       iconName: 'point',
  //       route: 'apps/products/list',
  //     }
  //   ],
  // },
  // {
  //   displayName: 'Budget',
  //   iconName: 'briefcase',
  //   route: 'apps/products',
  //   children: [
  //     {
  //       displayName: 'Budget',
  //       iconName: 'point',
  //       route: 'apps/products/add',
  //     }
  //   ],
  // },
  

 

  {
    displayName: 'Chart of Accounts',
    iconName: 'layout-list',
    route: 'apps/accounting/chart-of-accounts',
  },

  {
    displayName: 'Journal Entries',
    iconName: 'file-text',
    route: 'apps/accounting/journal-entries',
  },

  {
    displayName: 'General Ledger',
    iconName: 'book',
    route: 'apps/accounting/general-ledger',
  },

  {
    displayName: 'Financial Statements',
    iconName: 'chart-bar',
    route: 'apps/accounting/financial-statements',
  },

  {
    displayName: 'Budgets',
    iconName: 'calculator',
    route: 'apps/accounting/budgets',
  },

  {
    displayName: 'Financial Periods',
    iconName: 'calendar',
    route: 'apps/accounting/financial-periods',
  },

  {
    displayName: 'Tax Codes',
    iconName: 'receipt-tax',
    route: 'apps/accounting/tax-codes',
  },

  {
    displayName: 'Tax Transactions',
    iconName: 'file-invoice',
    route: 'apps/accounting/tax-transactions',
  },

  {
    displayName: 'Bills',
    iconName: 'script',
    route: 'apps/accounting/bills',
  },


  {
    navCap: 'Management',
  },

  {
    displayName: 'Users',
    iconName: 'users',
    route: 'apps/management',
    children: [
      {
        displayName: 'Add User',
        iconName: 'point',
        route: 'apps/management/users/add',
      },
      {
        displayName: 'Users List',
        iconName: 'point',
        route: 'apps/management/users',
      },
    ],
  },

  {
    displayName: 'Roles',
    iconName: 'shield',
    route: 'apps/management',
    children: [
      {
        displayName: 'Roles List',
        iconName: 'point',
        route: 'apps/management/roles',
      },
      {
        displayName: 'Add Role',
        iconName: 'point',
        route: 'apps/management/roles/add',
      }
    ],
  },

  {
    displayName: 'Permissions',
    iconName: 'key',
    route: 'apps/management',
    children: [
      {
        displayName: 'Permissions List',
        iconName: 'point',
        route: 'apps/management/permissions',
      },
      {
        displayName: 'Add Permission',
        iconName: 'point',
        route: 'apps/management/permissions/add',
      }
    ],
  },

  {
    displayName: 'Groups',
    iconName: 'users-group',
    route: 'apps/management',
    children: [
      {
        displayName: 'Groups List',
        iconName: 'point',
        route: 'apps/management/groups',
      },
      {
        displayName: 'Add Group',
        iconName: 'point',
        route: 'apps/management/groups/add',
      }
    ],
  },

  {
    displayName: 'Pages',
    iconName: 'file-text',
    route: 'apps/management',
    children: [
      {
        displayName: 'Pages List',
        iconName: 'point',
        route: 'apps/management/pages',
      },
      {
        displayName: 'Add Page',
        iconName: 'point',
        route: 'apps/management/pages/add',
      }
    ],
  },

  // {
  //   displayName: 'Companies',
  //   iconName: 'building',
  //   route: 'apps/management',
  //   children: [
  //     {
  //       displayName: 'Companies List',
  //       iconName: 'point',
  //       route: 'apps/management/companies',
  //     },
  //     {
  //       displayName: 'Add Company',
  //       iconName: 'point',
  //       route: 'apps/management/companies/add',
  //     }
  //   ],
  // },

 
];
